export const environmentShared = {
  production: true,
  moduleFederationUrl: {
    shell: '/shell',
    dashboard: '/dashboardremote',
    reports: '/reportsremote',
    visibility: '/visibilityremote',
    alerts: '/alertsremote',
    collaboration: '/collaborationremote',
    bat: '/batremote',
    admin: '/adminremote',
    common: '/commonremote',
    ewqf:'/ewqfremote',
    dataquality:'/dataqualityremote',
    eventmanagement:'/eventmanagementremote'
  },
  logOutURL: 'https://sso-stg.apll.com/oamsso/logout.html',
  localJson: false,
  // apiUrl: './assets/json',
  apiUrl: 'https://vna-sit.apllogistics.com',
  feedbackDates: [1, 3, 4],
  issuer: 'https://oktanp.apll.com/oauth2/default',
  clientId: '0oaf9a093qxPcrkTt1d7',
  appInsights: {
    instrumentationKey: '508226c1-19e7-498b-920e-6c8df52bc654',
  },
};
